import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Switch } from '@mui';
import './switch-label.scss';

export const SwitchLabel = memo(({ icon, label, toggled, onToggle, disabled, ...other }) => {
  if (icon) {
    return (
      <div styleName="toggle-root">
        <div styleName="small-toggle">
          <Switch
            checked={toggled}
            onChange={onToggle}
            disabled={disabled}
            color="primary"
            size="small"
            // A native `title` attribute is not an accessible name source for form controls -
            // the visible "toggle-label" div beside this switch isn't programmatically
            // associated with it either, so screen readers announced no label at all.
            inputProps={{ 'aria-label': label }}
            {...other}
          />
        </div>
        <div styleName="toggle-icon"> {icon} </div>
        <div styleName="toggle-label"> {label} </div>
      </div>
    );
  }
  return (
    <div styleName="toggle-root">
      <FormControlLabel
        styleName="toggle"
        control={
          <Switch
            checked={toggled}
            onChange={onToggle}
            disabled={disabled}
            color="primary"
            size="small"
            {...other}
          />
        }
        label={label}
        disabled={disabled}
      />
    </div>
  );
});

SwitchLabel.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  label: PropTypes.string,
  onToggle: PropTypes.func,
  toggled: PropTypes.bool
};

export default SwitchLabel;
